import React, { useState } from "react";
import Contact from "../Contact/Contact";
import Footer from "../Footer/Footer";
import Landing from "../Landing/Landing";
import Navbar from "../NavBar/Navbar";
import NavbarMenu from "../NavbarMenu/NavbarMenu";
import SideBar from "../SideBar/SideBar";
import schoollogo from "../../image/logo/schoollogo2.png";
import bulbLogo from "../../image/logo/bulb.png";
import rocketLogo from "../../image/logo/rocket.png";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useLayoutEffect } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";

import "./Content.css";
import "./Admission.css";

function Admission(props) {
  const { cover, sidebar_data, side_heading, side_sub_heading } = props;
  const [isScrolled, setIsScrolled] = useState(false);
  const [isShow, steIsShow] = useState(false);
  const handleScroll = (e) => {
    if (e.target.scrollTop > 0 && !isScrolled) {
      setIsScrolled(true);
    }
    if (e.target.scrollTop === 0) {
      setIsScrolled(false);
    }
  };
  const handleClick = () => {
    steIsShow(!isShow);
    console.log(isShow);
  };


  useEffect(() => {
    // 1) Init AOS
    AOS.init({
      duration: 900,
      once: true,
      easing: "ease-in-out",
      offset: 120,
    });

    // 2) Force refresh after a short delay (images, layout changes)
    //    This helps when assets load after initial render.
    const refreshTimeout = setTimeout(() => {
      if (AOS && typeof AOS.refresh === "function") AOS.refresh();
    }, 200);

    // 3) IntersectionObserver fallback: ensure elements get aos-animate
    //    even when AOS fails to mark them (helps with odd layouts).
    const elems = Array.from(document.querySelectorAll("[data-aos]"));
    if ("IntersectionObserver" in window && elems.length) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const el = entry.target;
            if (entry.isIntersecting) {
              el.classList.add("aos-animate");
              // If you only want it once, unobserve after first intersection:
              io.unobserve(el);
            }
          });
        },
        {
          root: null,
          rootMargin: "0px",
          threshold: 0.15, // trigger when ~15% visible
        }
      );

      elems.forEach((el) => io.observe(el));

      // cleanup
      return () => {
        clearTimeout(refreshTimeout);
        io.disconnect();
      };
    }

    return () => clearTimeout(refreshTimeout);
  }, []);


  return (
    <div className="content_main" onScroll={handleScroll}>
      <Navbar isScrolled={isScrolled} handleClick={handleClick} />
      <NavbarMenu isShow={isShow} handleClick={handleClick} />
      {/* <Landing video={false} cover={cover} /> */}

      <div className="container-full">
        <div className="admission-page">
          {/* Hero Section */}
          <section className="text-white text-start admissionBanner">
            <video preload="true" className="video-container" autoPlay loop muted controls>
              <source src={require("../../image/boardingadmission/bordingbanner.mp4")} type="video/mp4" />
            </video>
            <div className="container-full admission-container">
              <div className="indideBanner">
                <h1 className="display-5 fw-bold mb-3 ad-text ">Admissions Open for 2027–2028</h1>
                <p className="lead mb-4">Nursery–Grade 9 &amp; 11</p>
                <p className="lead mb-4">
                  Strong values, caring home, world-class learning and affordability meet excellence
                </p>
                <p className="lead mb-4">
                  Academic rigor. Individual attention. Holistic well-being. At HGS Bhimtal, <br />
                  your child is not just another student—they are seen, valued, and nurtured every step of the way.
                </p>
                <br />
                <a href="contact-us" className="btn btn-lg px-4 text-white rounded-pill hg-bgred">
                  <b>Apply Now</b>
                </a>
                <br />
                <br />
                <a href="book-tour" className="text-white text-decoration-underline rounded-pill my-4">
                  <b>Schedule a Campus Tour</b>
                </a>
              </div>
            </div>
          </section>

          {/* Why Parents Choose Us */}
          <section id="why-us" className="">
            <div className="container-full text-center spacious imageshade text-white">
              <h2 className="fw-bold mb-4 headingfont text-white">Why Parents Choose Us</h2>
              <p className="quotes text-white">"Where Academic Excellence Meets Emotional Safety"</p>
              <div className="key-heightlights text-start increasLine ">
                {/* <h2 className="text-white">Key Highlights </h2>                 */}
              </div>


              <div className="row g-4">


                <Swiper
                  modules={[Autoplay]}
                  spaceBetween={80}
                  slidesPerView={1}
                  autoplay={{ delay: 3000 }}
                  breakpoints={{
                    576: { slidesPerView: 1 },
                    992: { slidesPerView: 3 },
                  }}
                >

                  <SwiperSlide>
                    <div className="col-12">
                      <div className="info-card">
                        <div className="icon-placeholder">
                          <svg width="100" height="100" viewBox="10 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="32" cy="24" r="12" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M32 17L34.4721 21.5279L39 22.2361L35.5 25.7639L36.4721 30.2361L32 28L27.5279 30.2361L28.5 25.7639L25 22.2361L29.5279 21.5279L32 17Z"

                              stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M24 36L24 52L32 48L40 52V36" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>

                        </div>
                        <h6 className="infotext fw-semibold text-primary mb-0 text-center">
                          <h4 className="text-primary ">Proven Results</h4><br />
                          100% pass rate
                        </h6>
                      </div>
                    </div>

                    {/* Card 1 */}
                  </SwiperSlide>


                  <SwiperSlide>
                    <div className="col-12 ">
                      <div className="info-card">
                        <div className="icon-placeholder">
                          <svg width="100" height="100" viewBox="10 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="22" cy="24" r="6" stroke="black" stroke-width="3" />
                            <circle cx="42" cy="24" r="6" stroke="black" stroke-width="3" />
                            <path d="M16 44C16 38 22 36 26 36H28C30 36 34 38 34 44" stroke="black" stroke-width="3" stroke-linecap="round" />
                            <path d="M48 44C48 38 42 36 38 36H36C34 36 30 38 30 44" stroke="black" stroke-width="3" stroke-linecap="round" />
                            <path d="M28 26L36 26" stroke="black" stroke-width="3" stroke-linecap="round" />
                          </svg>

                        </div>
                        <h6 className="infotext fw-semibold text-primary mb-0 text-center">
                          <h4 className="text-primary">National merit holders. </h4><br />
                          <p></p>
                        </h6>
                      </div>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide>
                    <div className="col-12 ">
                      <div className="info-card">
                        <div className="icon-placeholder">
                          <svg width="100" height="100" viewBox="10 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="22" cy="24" r="6" stroke="black" stroke-width="3" />
                            <circle cx="42" cy="24" r="6" stroke="black" stroke-width="3" />
                            <path d="M16 44C16 38 22 36 26 36H28C30 36 34 38 34 44" stroke="black" stroke-width="3" stroke-linecap="round" />
                            <path d="M48 44C48 38 42 36 38 36H36C34 36 30 38 30 44" stroke="black" stroke-width="3" stroke-linecap="round" />
                            <path d="M28 26L36 26" stroke="black" stroke-width="3" stroke-linecap="round" />
                          </svg>

                        </div>
                        <h6 className="infotext fw-semibold text-primary mb-0 text-center">
                          <h4 className="text-primary">No Child Invisible Program </h4><br />
                          1:30 Ratio
                        </h6>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>


                    <div className="col-12">
                      <div className="info-card">
                        <div className="icon-placeholder">

                          <svg width="90" height="90" viewBox="0 0 70 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="32" cy="32" r="28" stroke="black" stroke-width="3" stroke-linecap="round" />
                            <rect x="22" y="18" width="20" height="32" rx="2" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M26 24H38M26 30H38M26 36H32" stroke="black" stroke-width="2.5" stroke-linecap="round" />
                          </svg>
                        </div>
                        <h6 className="infotext fw-semibold text-primary mb-0 text-center">
                          <h4 className="text-primary">Holistic Progress Report </h4><br />
                          360 degree assessment
                        </h6>
                      </div>
                    </div>

                  </SwiperSlide>
                  <SwiperSlide>

                    <div className="col-12">
                      <div className="info-card">
                        <div className="icon-placeholder">
                          <svg width="100" height="100" viewBox="10 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="14" y="16" width="36" height="28" rx="2" stroke="black" stroke-width="3" stroke-linecap="round" />
                            <path d="M22 48H42" stroke="black" stroke-width="3" stroke-linecap="round" />
                            <path d="M32 38V48" stroke="black" stroke-width="3" stroke-linecap="round" />
                            <path d="M48 14C50.2091 14 52 15.7909 52 18" stroke="black" stroke-width="2" stroke-linecap="round" />
                            <path d="M52 10C55.3137 10 58 12.6863 58 16" stroke="black" stroke-width="2" stroke-linecap="round" />
                          </svg>

                        </div>
                        <h6 className="infotext fw-semibold text-primary mb-0 text-center">
                          <h4 className="text-primary">Digital Integration</h4><br />   
                          <p></p>                       
                        </h6>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>


                    <div className="col-12">
                      <div className="info-card">
                        <div className="icon-placeholder">
                          <svg width="100" height="100" viewBox="10 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M28 12V28L18 44C18 46.2091 19.7909 48 22 48H42C44.2091 48 46 46.2091 46 44L36 28V12" stroke="black" stroke-width="3" stroke-linecap="round" />
                            <circle cx="40" cy="20" r="3" stroke="black" stroke-width="3" />
                          </svg>

                        </div>
                        <h6 className="infotext fw-semibold text-primary mb-0 text-center">
                          <h4 className="text-primary">Explorer's Lab</h4><br />
                          STEAM, ATL, and Robotics
                        </h6>
                      </div>
                    </div>

                  </SwiperSlide>
                  <SwiperSlide>

                    <div className="col-12">
                      <div className="info-card">
                        <div className="icon-placeholder">
                          <svg width="100" height="100" viewBox="10 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M32 10L16 18V32C16 44 24 52 32 54C40 52 48 44 48 32V18L32 10Z" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M26 32L30 36L38 28" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                            <rect x="26" y="40" width="12" height="8" rx="2" stroke="black" stroke-width="2" />
                          </svg>

                        </div>
                        <h6 className="infotext fw-semibold text-primary mb-0 text-center">
                          <h4 className="text-primary">Safety in the Culture</h4><br />     
                          <p></p>                     
                        </h6>
                      </div>
                    </div>

                  </SwiperSlide>
                  <SwiperSlide>

                    <div className="col-12">
                      <div className="info-card">
                        <div className="icon-placeholder">

                          <svg width="100" height="100" viewBox="10 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="22" cy="24" r="6" stroke="black" stroke-width="3" />
                            <circle cx="42" cy="24" r="6" stroke="black" stroke-width="3" />
                            <path d="M16 44C16 38 22 36 26 36H28C30 36 34 38 34 44" stroke="black" stroke-width="3" stroke-linecap="round" />
                            <path d="M48 44C48 38 42 36 38 36H36C34 36 30 38 30 44" stroke="black" stroke-width="3" stroke-linecap="round" />
                            <path d="M28 26L36 26" stroke="black" stroke-width="3" stroke-linecap="round" />
                          </svg>
                        </div>
                        <h6 className="infotext fw-semibold text-primary mb-0 text-center">
                          <h4 className="text-primary">Mentor Match Program </h4><br />
                          Alumni network and Strong Teacher Connect
                        </h6>
                      </div>
                    </div>

                  </SwiperSlide>
                  <SwiperSlide>

                    <div className="col-12">
                      <div className="info-card">
                        <div className="icon-placeholder">
                          <svg width="100" height="100" viewBox="10 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="22" cy="24" r="6" stroke="black" stroke-width="3" />
                            <circle cx="38" cy="28" r="4" stroke="black" stroke-width="3" />
                            <path d="M14 44C14 38 20 36 24 36H26C30 36 34 38 34 44" stroke="black" stroke-width="3" stroke-linecap="round" />
                            <path d="M36 36H42C46 36 50 38 50 44" stroke="black" stroke-width="3" stroke-linecap="round" />
                            <path d="M30 18L34 14L38 18" stroke="black" stroke-width="3" stroke-linecap="round" />
                          </svg>

                        </div>
                        <h6 className="infotext fw-semibold text-primary mb-0 text-center">
                          <h4 className="text-primary">Parent as Partner Framework</h4><br />  
                          <p></p>                        
                        </h6>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>

                    <div className="col-12">
                      <div className="info-card">
                        <div className="icon-placeholder">
                          <svg width="100" height="100" viewBox="10 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="32" cy="32" r="14" stroke="black" stroke-width="3" />
                            <path d="M32 18V14M32 50V46M18 32H14M50 32H46" stroke="black" stroke-width="2.5" stroke-linecap="round" />
                            <path d="M32 32L38 26M32 32L26 38" stroke="black" stroke-width="3" stroke-linecap="round" />
                          </svg>

                        </div>
                        <h6 className="infotext fw-semibold text-primary mb-0 text-center">
                          <h4 className="text-primary">Life Skills program</h4><br />
                          preparing for global citizenship
                        </h6>
                      </div>
                    </div>

                  </SwiperSlide>


                </Swiper>

              </div>

            </div>
          </section>

          {/* Boarding Life */}
          <section className="py-5 boardinglife">
            <div className="container spacious">
              <div className="row align-items-center g-5 text-center">
                <div className="col-md-12">
                  <h2 className="fw-bold mb-3 headingfont">Boarding Life</h2>
                  <p className="quotes">“A Second Home, Safe and Supportive”</p>
                  <p className="">
                    Our day-cum-boarding system ensures children experience comfort, security, and growth in a nurturing environment. Separate hostels for boys and girls with round-the-clock supervision, nutritious meals, health care, and pastoral guidance make our campus a true home away from home.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Holistic Growth Beyond Books */}
          <section className="bg-white">
            <div className="container text-start spacious ">
              <div className="holisticcontainer spacious">
                <div className="holistcontent">
                  <h2 className="fw-bold mb-4 headingfont holistictext">
                    <span className="hol">Holistic Growth </span>
                    <span className="beyou">Beyond Books</span>
                  </h2>
                  <p className="quotes">“Building Confident, Compassionate, Future-Ready Leaders”</p>
                  <br />
                  <br />
                  <p className="mx-auto text-start increasLine">
                    <ul className="slide-in-left">
                      <li>Sports: Cricket, football, basketball, tennis and indoor games.</li>
                      <li>Arts & Culture: Music, drama, visual arts, debates and exhibitions.</li>
                      <li>Life Skills: Environmental awareness, leadership programs and community service.</li>
                      <li>Well-being: Counsellors, mentorship and mindfulness activities.</li>
                    </ul>
                  </p>
                </div>
                <div className="holistimage">
                  <img className="holistimageimg" src={require("../../image/boardingadmission/girlimage.webp")} ></img>
                </div>

              </div>

            </div>
          </section>

          {/* Campus at a Glance */}
          <section className="py-5">
            <div className="container spacious">
              <h2 className="fw-bold text-center mb-4 headingfont">Campus at a Glance</h2>
              <p className="quotes text-center">“42 Acres of Inspiration in the Lap of Nature”</p>
              <div className="row text-center g-4">

                <div className="col-md-6 col-lg-3" data-aos="fade-up">
                  <div className="atglance">

                    <h5 className="fw-semibold text-white">
                      <i class="fa fa-shield-halved glanceimage" aria-hidden="true"></i><br />
                      Safe, serene Bhimtal location in Uttarakhand.</h5>
                  </div>
                </div>

                <div className="col-md-6 col-lg-3 " data-aos="fade-up">
                  <div className="atglance">
                    <h5 className="fw-semibold text-white">
                      <i class="fa fa-flask-vial glanceimage" aria-hidden="true"></i><br />
                      State-of-the-art science and computer labs.</h5>
                  </div>
                </div>

                <div className="col-md-6 col-lg-3" data-aos="fade-up">
                  <div className="atglance">
                    <h5 className="fw-semibold text-white">
                      <i class="fa fa-chalkboard glanceimage" aria-hidden="true"></i><br />
                      Digital smart classrooms and library.</h5>
                  </div>
                </div>

                <div className="col-md-6 col-lg-3" data-aos="fade-up">
                  <div className="atglance">
                    <h5 className="fw-semibold text-white">
                      <i class="fa fa-volleyball glanceimage" aria-hidden="true"></i> <br />
                      Spacious sports grounds and indoor facilities.</h5>
                  </div>
                </div>

              </div>
            </div>
            <img className="campusbottom nophone" src={require("../../image/boardingadmission/newreverse.png")} ></img>
          </section>

          {/* Parent & Alumni Voices Carousel */}
          <section className="py-5 testimonialcarou">
            <div className="container text-center spacious">
              <h2 className="fw-bold text-white headingfont">
                Parent & Alumni Voices & Achievements
              </h2>
              <p className="quotes text-center text-white mb-5">“Trusted by Parents. Proven by Results.”</p>
              <div id="testimonialCarousel" className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-inner">
                  <div className={`carousel-item active`}>
                    <div className="col-md-8 mx-auto">
                      <div className="p-4 bg-white rounded-4 shadow-sm">
                        <p className="text-muted fst-italic mb-4 text-start">
                          I am a proud mother of Sparsh Soni Class VII studying at Hermann Gmeiner School, Bhimtal. <br />
                          Our experience with this school has been truly wonderful. The school has a very caring and friendly environment. The teachers are kind, patient, and always ready to help the children. I have seen a lot of positive changes in my child since joining this school. The administration of the school is very well managed and cooperative. They always listen to parents and value our suggestions. The way they handle each child’s needs is really impressive. The teachers pay attention to both studies and overall development. The school uses new and innovative ideas to make learning fun. My child enjoys going to school every day with excitement. They focus on discipline, creativity, and moral values equally. classrooms are clean and well-equipped for modern learning. The school gives equal importance to sports, art, and cultural activities. I really appreciate how they encourage each child’s unique talent. The atmosphere of the school is safe and full of positive energy. I feel very confident and happy about my child’s future here. The principal and staff truly care for every student like their own. I am thankful to Hermann Gmeiner School, Bhimtal for giving such quality education. <br />
                          As a mother, I feel proud that my child is part of this wonderful institution.
                        </p>
                        <div className="testtimonial-bottom">
                          <div className="parentimage"><img src={require("../../image/boardingadmission/nelam.png")} /></div>
                          <h6 className="my-3 fw-bold mb-0">Mrs Neelam Kaushal</h6>
                          <small className="text-muted">Mother of Sparsh Soni</small>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={`carousel-item`}>
                    <div className="col-md-8 mx-auto">
                      <div className="p-4 bg-white rounded-4 shadow-sm">
                        <p className="text-muted fst-italic mb-4 text-start">
                          We are so impressed with the school system and the discipline of the school. This school provides a wonderful balance between academics and co-curricular activities. <br />
                          Teachers are also very nice and supportive, and I thank the teachers for creating a positive learning environment, and for their patience and dedication to our child's development.
                        </p>
                        <div className="testtimonial-bottom">
                          <div className="parentimage"><img src={require("../../image/boardingadmission/puran.png")} /></div>
                          <h6 className="my-3 fw-bold mb-0">Mr. Puran Singh Nayal </h6>
                          <small className="text-muted">Father of Payal Nayal XI C  (Day scholar)</small>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={`carousel-item`}>
                    <div className="col-md-8 mx-auto">
                      <div className="p-4 bg-white rounded-4 shadow-sm">
                        <p className="text-muted fst-italic mb-4 text-start">
                          I wanted to take a moment to express my appreciation for the wonderful work the school is doing in shaping young minds. My child, Gayatri Singh has been having a great learning experience, and I truly appreciate the dedication of the teachers and staff. <br />
                          The school's positive environment, engaging teaching methods, and focus on overall development have made a significant impact. <br />
                          Thank you for your hard work and commitment to providing quality education. We feel grateful to be a part of this school community.<br />
                        </p>
                        <div className="testtimonial-bottom">
                          <div className="parentimage"><img src={require("../../image/boardingadmission/neema.png")} /></div>
                          <h6 className="my-3 fw-bold mb-0">Ms. Neema Negi</h6>
                          <small className="text-muted">Mother of Gayatri Singh X (A) (Day scholar)</small>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={`carousel-item`}>
                    <div className="col-md-8 mx-auto">
                      <div className="p-4 bg-white rounded-4 shadow-sm">
                        <p className="text-muted fst-italic mb-4 text-start">
                          I Dr. Mukta mother of Master Arjun Gehlawat of Pre Nursery. I am very happy with my son’s progress in pre-nursery. He enjoys going to school and has shown great improvement in confidence, communication, and social skills. I appreciate the teacher's care, patience, and creative teaching methods. Thank you for providing such a joyful and nurturing environment.
                        </p>
                        <div className="testtimonial-bottom">
                          <div className="parentimage"><img src={require("../../image/boardingadmission/mukta.png")} /></div>
                          <h6 className="my-3 fw-bold mb-0">Dr Mukta </h6>
                          <small className="text-muted">Mother of  Arjun Gehlawat</small>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={`carousel-item`}>
                    <div className="col-md-8 mx-auto">
                      <div className="p-4 bg-white rounded-4 shadow-sm">
                        <p className="text-muted fst-italic mb-4 text-start">
                          Hermann Gmeiner School, Bhimtal, is a wonderful institution that provides not only quality education but also a nurturing environment for the all-round development of students. <br />
                          As parents, we are very happy and satisfied with Hermann Gmeiner School, Bhimtal. The school provides a safe, caring, and positive environment where our child feels encouraged to learn and grow. The teachers are dedicated and take personal interest in every student’s progress, not only in academics but also in character development.<br />
                          We appreciate the school’s focus on discipline, values, and overall personality development. The communication between teachers and parents is also very good, which helps us stay connected with our child’s education.<br />
                          The peaceful atmosphere and beautiful surroundings of the campus make it a wonderful place for learning. We truly thank the school management and staff for their efforts in shaping our child’s future with love, patience, and commitment.<br />
                          We feel proud and grateful to be part of the Hermann Gmeiner School family.
                        </p>
                        <div className="testtimonial-bottom">
                          <div className="parentimage"><img src={require("../../image/boardingadmission/rajesh.png")} /></div>
                          <h6 className="my-3 fw-bold mb-0">Rev. Rajesh Lal.</h6>
                          <small className="text-muted">Father of  Arpit Lal</small>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={`carousel-item`}>
                    <div className="col-md-8 mx-auto">
                      <div className="p-4 bg-white rounded-4 shadow-sm">
                        <p className="text-muted fst-italic mb-4 text-start">
                          Ms. Chhavi, mother of Kanak Baliyan, a Class 7 student, and Priyanshu, a Class 4 student. The best part about this school is its infrastructure and the diverse backgrounds of teachers and students from different parts of India. Unlike other schools, the school does not charge parents for school development. The teachers are very friendly, supportive, and helpful. They have boosted our child's confidence and helped him overcome stage fright. Thanks to all the teachers, including Ms. Mahima Bhatt (Principal), for their visionary leadership. <br />
                          I am very happy with the extracurricular activities. Your commitment to his development is invaluable.
                        </p>
                        <div className="testtimonial-bottom">
                          <div className="parentimage"><img src={require("../../image/boardingadmission/chavi.png")} /></div>
                          <h6 className="my-3 fw-bold mb-0">Ms. Chhavi</h6>
                          <small className="text-muted">Mother of Kanak Baliyan</small>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={`carousel-item`}>
                    <div className="col-md-8 mx-auto">
                      <div className="p-4 bg-white rounded-4 shadow-sm">
                        <p className="text-muted fst-italic mb-4 text-start">
                          I am truly delighted with the school’s balanced approach, where, on one hand, tall, lush trees connect children to nature and on the other, smart boards link them to modern technology. The thoughtful blend of curriculum, vibrant clubs, and sports nurtures the all-round development of both my children. Guided by teachers’ genuine love, compassion, and care, my children continue to grow holistically. I feel happy to see how life-skills and music classes deepen their connection to our cultural roots, while celebrations of Indian states through music, cuisine, and attire enrich their cultural understanding. HGS’s student-centric initiatives foster a disciplined yet caring environment that promotes solidarity and mutual respect. I am proud to see my children evolving into compassionate, confident, and culturally grounded individuals.
                        </p>
                        <div className="testtimonial-bottom">
                          <div className="parentimage"><img src={require("../../image/boardingadmission/santosh.png")} /></div>
                          <h6 className="my-3 fw-bold mb-0">Dr. Santoshi Sengupta  </h6>
                          <small className="text-muted">Mother of Ahana Paul (III B) & Adhrit Paul(IV A)</small>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={`carousel-item`}>
                    <div className="col-md-8 mx-auto">
                      <div className="p-4 bg-white rounded-4 shadow-sm">
                        <p className="text-muted fst-italic mb-4 text-start">
                          As a parent, I am truly pleased with the quality of education and overall development that my child has received at the school. The teachers are dedicated and supportive, ensuring that every student receives the attention they need to grow academically as well as personally. <br />
                          I have noticed a great improvement in my child’s confidence, communication skills, and sense of responsibility. The school not only focuses on academics but also encourages participation in co-curricular activities, which helps in building a well-rounded personality. The regular communication between teachers and parents helps us stay updated about our child’s progress. I sincerely appreciate the efforts of the school management and teaching staff for creating such a positive and nurturing learning environment. <br />
                          We are grateful to be part of this institution and look forward to seeing our child continue to excel under your guidance. Thanks and Regards.
                        </p>
                        <div className="testtimonial-bottom">
                          <div className="parentimage"><img src={require("../../image/boardingadmission/somesh.png")} /></div>
                          <h6 className="my-3 fw-bold mb-0">Mr. Somesh Paliwal</h6>
                          <small className="text-muted">Father of Pratishtha Paliwal XI C</small>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={`carousel-item`}>
                    <div className="col-md-8 mx-auto">
                      <div className="p-4 bg-white rounded-4 shadow-sm">
                        <p className="text-muted fst-italic mb-4 text-start">
                          I Naveen Chandra Arya father of Gauravi Arya of Preparatory. The school has excellent infrastructure and wonderful teachers who encourage my child’s creativity and learning. I am extremely happy with the holistic development approach of the school. My child has shown tremendous growth not just academically but also in extracurricular activities like sports and arts. The teachers are supportive and nurturing. The wonderful learning journey of my child is ongoing.
                        </p>
                        <div className="testtimonial-bottom">
                          <div className="parentimage"><img src={require("../../image/boardingadmission/naveen.png")} /></div>
                          <h6 className="my-3 fw-bold mb-0">Mr. Naveen Chandra Arya </h6>
                          <small className="text-muted">Father of Gauravi Arya Preparatory</small>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={`carousel-item`}>
                    <div className="col-md-8 mx-auto">
                      <div className="p-4 bg-white rounded-4 shadow-sm">
                        <p className="text-muted fst-italic mb-4 text-start">
                          PTM was organised with good interaction between teachers and parents. It is always good for us to discuss regarding the performance of our ward. We also find these analysis good for betterment of our ward’s academic performance.
                        </p>
                        <div className="testtimonial-bottom">
                          <div className="parentimage"><img src={require("../../image/boardingadmission/asha.png")} /></div>
                          <h6 className="my-3 fw-bold mb-0">Mrs. Asha Rani</h6>
                          <small className="text-muted">Mother of Mayank Kumar Class - 11 A</small>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={`carousel-item`}>
                    <div className="col-md-8 mx-auto">
                      <div className="p-4 bg-white rounded-4 shadow-sm">
                        <p className="text-muted fst-italic mb-4 text-start">
                          As parent, I feel truly delighted and proud that my daughter is part of Hermann Gmeiner School, Bhimtal because the school prioritizes the holistic development of every child. The school provides an environment where learning extends beyond the classroom — encouraging children to explore their interests, try new things, and discover their potential in a joyful and supportive atmosphere. The various creativity clubs and AI lab is like icing on the cake. <br />
                          The green and serene environment adds to the school’s charm, creating the perfect setting for young minds to learn, grow, and thrive. <br />
                          Further, the visionary leadership of the Principal reflects in every aspect of the school’s functioning — from its progressive approach to education to the emphasis on values, discipline, and creativity. The teachers are also dedicated, well-mannered, and deeply committed to nurturing each child with care and compassion. <br />
                          I have seen my child grow in confidence, curiosity, and character — qualities that go far beyond academics. <br />
                          It fills me with immense happiness to see my child waking up every morning, excitedly, to attend her school and return home with lot of stories and experiences. <br />
                          The school is definitely shaping children into well-rounded individuals, ready to face the world with wisdom, kindness, and courage.
                        </p>
                        <div className="testtimonial-bottom">
                          <div className="parentimage"><img src={require("../../image/boardingadmission/shalini.png")} /></div>
                          <h6 className="my-3 fw-bold mb-0">Mrs Shalini Pandey </h6>
                          <small className="text-muted">Mother Ishanvi Mahapatra V B</small>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={`carousel-item`}>
                    <div className="col-md-8 mx-auto">
                      <div className="p-4 bg-white rounded-4 shadow-sm">
                        <p className="text-muted fst-italic mb-4 text-start">
                          I, Amar Nath Goswami, as parent of Ankit Nath Goswami, the Head Boy of Hermann Gmeiner School, would like to take this opportunity to express our heartfelt gratitude and appreciation for the exceptional learning environment and the holistic development that the school has provided to our son over the years. <br />
                          Hermann Gmeiner School has been a remarkable platform for nurturing not only Ankit's academic abilities but also his personality and leadership skills. The school’s emphasis on excellence in academics is evident through Ankit’s consistent performance, and we are pleased to see how the curriculum challenges and encourages students to think critically, stay curious, and pursue knowledge with a passion. The faculty is dedicated and always approachable, making learning a rewarding experience.<br />
                          Beyond academics, what truly stands out about Hermann Gmeiner School is its focus on co-curricular activities. The wide array of opportunities available—ranging from sports and arts to debates and cultural events—has helped Ankit explore and enhance his diverse talents. These activities have been invaluable in fostering his teamwork, time management, and creative skills, which we believe are crucial for personal growth.<br />
                          The environment at Hermann Gmeiner School is one of inclusivity, respect, and support. It is a space where students feel safe, encouraged, and empowered to be their best selves. For Ankit, this atmosphere has been instrumental in shaping his leadership qualities.<br />
                          Thank you to the entire faculty and administration of Hermann Gmeiner School for providing such a nurturing and empowering environment. We will always be grateful for the positive impact you’ve had on Ankit’s life.
                        </p>
                        <div className="testtimonial-bottom">
                          <div className="parentimage"><img src={require("../../image/boardingadmission/amarnath.png")} /></div>
                          <h6 className="my-3 fw-bold mb-0">Amar Nath Goswami</h6>
                          <small className="text-muted">Father of Ankit Nath Goswami XII A</small>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#testimonialCarousel"
                  data-bs-slide="prev"
                >
                  <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                </button>
                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#testimonialCarousel"
                  data-bs-slide="next"
                >
                  <span className="carousel-control-next-icon" aria-hidden="true"></span>
                </button>
              </div>
            </div>

            <img className="campusbottomfne nophone" src={require("../../image/boardingadmission/newreverseflip.png")} ></img>

          </section>


          {/* Achievement Highlights */}
          <section className="achievement-timeline-section py-5">
            <div className="container">
              <h2 className="fw-bold mb-5 text-center display-6 text-primary">
                Achievement Highlights
              </h2>

              <div className="timeline position-relative">

                <div className="timeline-item left" data-aos="fade-right">
                  <div className="timeline-content rounded-4 shadow-sm p-4">
                    <div className="d-flex align-items-center mb-3">
                      <h5 className="fw-semibold text-white mb-0">
                        100% Board Results 2025!
                      </h5>
                    </div>
                    <p className="small mb-0 text-white">
                      Congratulations to the students for their outstanding results in Classes X and XII! We wish them continued success in all their future endeavours and believe they will achieve great heights.
                      <br /><img src={require("../../image/boardingadmission/result12.png")} className="highimageleft" />
                    </p>
                  </div>
                </div>

                <div className="timeline-item right" data-aos="fade-left">
                  <div className="timeline-content hg-bgred rounded-4 shadow-sm p-4">
                    <div className="d-flex align-items-center mb-3">
                      <h5 className="fw-semibold text-white mb-0">
                        Major Milestone Unlocked- City Toppers in 2025!
                      </h5>
                    </div>
                    <p className="small mb-0 text-white">
                      We are beyond proud to announce that our students have emerged as CITY TOPPERS at Bhimtal, in both Class 10 and Class 12 board examinations—a moment of glory not just for them, but for our entire school community! <br />
                      This achievement is more than just marks—it's a testament to hard work, consistent mentoring, and the spirit of excellence that defines our schools.
                      <br /><img
                        src={require("../../image/boardingadmission/citytopper.png")} alt="City Toppers" className="highimageleft" />
                    </p>
                  </div>
                </div>

                <div className="timeline-item left" data-aos="fade-right">
                  <div className="timeline-content hg-blue  rounded-4 shadow-sm p-4">
                    <div className="d-flex align-items-center mb-3">
                      <h5 className="fw-semibold text-white mb-0">
                        Redefining the Future of Learning!
                      </h5>
                    </div>
                    <p className="small mb-0 text-white">
                      We are proud to share that Hermann Gmeiner Day-Cum-Boarding School, Bhimtal (Uttarakhand) has been ranked No. 3 in India and No. 1 in Uttarakhand in the category of AI–Integrated Learning Champion at the EducationWorld Grand Jury India School Rankings 2025–26.  <br />
                      This recognition reflects our unwavering commitment to embracing the evolving landscape of education — where technology empowers learning, and AI becomes a tool to unlock imagination, innovation, and inquiry.<br />
                      At Hermann Gmeiner Day-Cum-Boarding School, we are shaping an ecosystem that equips our students not just for today’s world, but for the intelligent, adaptive, and collaborative world of tomorrow.
                      <br /> <img className="highimageleft" src={require("../../image/boardingadmission/aiintegration.png")} />
                    </p>
                  </div>
                </div>


                <div className="timeline-item right" data-aos="fade-left">
                  <div className="timeline-content rounded-4 shadow-sm p-4">
                    <div className="d-flex align-items-center mb-3">
                      <h5 className="fw-semibold text-white mb-0">
                        Hermann Gmeiner School, Bhimtal has been awarded the Best Day Cum Boarding School in Nainital District at the National School Awards 2025!
                      </h5>
                    </div>
                    <p className="small mb-0 text-white">
                      The prestigious ceremony, held at the elegant Radisson Blu Hotel, Delhi, brought together some of the country’s most respected educators and institutions to honour excellence in education. <br />
                      This recognition is more than just a trophy—it reflects our unwavering commitment to creating a safe, nurturing, and future-ready learning environment for every child who walks through our doors.
                      <br /> <img className="highimageleft" src={require("../../image/boardingadmission/boarding.png")} />
                    </p>
                  </div>
                </div>


                <div className="timeline-item left" data-aos="fade-right">
                  <div className="timeline-content hg-bgred  rounded-4 shadow-sm p-4">
                    <div className="d-flex align-items-center mb-3">

                      <h5 className="fw-semibold text-white mb-0">
                        HP IDEA School
                      </h5>
                    </div>
                    <p className="small mb-0 text-white">
                      With great pride, we share another milestone in our journey of excellence! Our school has been recognized as an *HP IDEA School* by the *HP Innovation and Digital Education Academy* for our innovations in digital pedagogy and technical expertise. This recognition reaffirms our approach to integrating cutting-edge technology into our teaching practices.  <br />
                      We look forward to applying these learnings to enrich our curriculum and enhance the learning experience for our students in the days to come.
                      <br /><img className="highimageleft" src={require("../../image/boardingadmission/hpidea.png")} />
                    </p>
                  </div>
                </div>


                <div className="timeline-item right" data-aos="fade-left">
                  <div className="timeline-content hg-blue rounded-4 shadow-sm p-4">
                    <div className="d-flex align-items-center mb-3">

                      <h5 className="fw-semibold text-white mb-0">
                        CAT exam and securing admission to IIM Lucknow
                      </h5>
                    </div>
                    <p className="small mb-0 text-white">
                      Nikhil Prakash’s remarkable achievement of clearing the CAT exam and securing admission to IIM Lucknow is a powerful reflection of his dedication and relentless hard work. It is heartwarming to see alumnus of Hermann Gmeiner School reaching such heights. His success story not only serves as a testament to his perseverance but also motivates current students to aspire for excellence, demonstrating that with determination, remarkable accomplishments are within reach regardless of one's background.
                      <br /><img className="highimageleft" src={require("../../image/boardingadmission/cat.png")} />
                    </p>
                  </div>
                </div>

                <div className="timeline-item left" data-aos="fade-right">
                  <div className="timeline-content rounded-4 shadow-sm p-4">
                    <div className="d-flex align-items-center mb-3">

                      <h5 className="fw-semibold text-white mb-0">
                        Selection for the prestigious Lodha Genius Program 2025
                      </h5>
                    </div>
                    <p className="small mb-0 text-white">
                      Hermann Gmeiner School Bhimtal student Yugal Kishore Sanwal, has been selected for the prestigious Lodha Genius Program 2025 — a highly selective, fully funded scholarship that supports exceptional students in Mathematics and Science. <br />
                      It is a fully funded scholarship, which means all of the student's costs will be covered. The program includes a special one-month free campus experience at Ashoka University in Sonipat each year, along with online learning and mentoring throughout the program.
                      <br /><img className="highimageleft" src={require("../../image/boardingadmission/lodha.png")} />
                    </p>
                  </div>
                </div>


                <div className="timeline-item right" data-aos="fade-left">
                  <div className="timeline-content hg-bgred  rounded-4 shadow-sm p-4">
                    <div className="d-flex align-items-center mb-3">

                      <h5 className="fw-semibold text-white mb-0">
                        Selection in JEE Main
                      </h5>
                    </div>
                    <p className="small mb-0 text-white">
                      What does it take to turn aspirations into achievements? Determination, perseverance, and an unwavering belief in oneself! <br />
                      We are thrilled to share that Samyak Gaur, a bright mind from Hermann Gmeiner School, Bhimtal, has successfully cleared JEE Main. Join us in congratulating Samyak on this incredible milestone!
                      <br /><img className="highimageleft" src={require("../../image/boardingadmission/jee.png")} />
                    </p>
                  </div>
                </div>

                <div className="timeline-item left" data-aos="fade-right">
                  <div className="timeline-content hg-blue rounded-4 shadow-sm p-4">
                    <div className="d-flex align-items-center mb-3">

                      <h5 className="fw-semibold text-white mb-0">
                        State-level swimming championship
                      </h5>
                    </div>
                    <p className="small mb-0 text-white">
                      Master Ashish of Class IX participated in the state-level swimming championship on 26th October 2024 at Gola Par Stadium, Haldwani, where he won a Gold Medal, a Trophy, and a bronze in different events. He has also been selected to compete in the National Level Championship on 14th November 2024.
                      <br /><img className="highimageleft" src={require("../../image/boardingadmission/swiming.png")} />
                    </p>
                  </div>
                </div>


                <div className="timeline-item right" data-aos="fade-left">
                  <div className="timeline-content rounded-4 shadow-sm p-4">
                    <div className="d-flex align-items-center mb-3">

                      <h5 className="fw-semibold text-white mb-0">
                        NDA Selection
                      </h5>
                    </div>
                    <p className="small mb-0 text-white">
                      There is no greater joy for a principal than witnessing the young buds of their school blossom into remarkable individuals. Anurag Kohli, an alumnus of Hermann Gmeiner School Bhimtal, Batch of 2019, has successfully completed his NDA training and is now set to begin his journey as a Flying Officer. Congratulations on this extraordinary achievement!
                      <br /><img className="highimageleft" src={require("../../image/boardingadmission/nda.png")} />
                    </p>
                  </div>
                </div>

                <div className="timeline-item left" data-aos="fade-right">
                  <div className="timeline-content hg-bgred  rounded-4 shadow-sm p-4">
                    <div className="d-flex align-items-center mb-3">

                      <h5 className="fw-semibold text-white mb-0">
                        Civil Services Selection
                      </h5>
                    </div>
                    <p className="small mb-0 text-white">
                      We take immense pride in celebrating the extraordinary achievement of our alumna, Saumya Garbyal, batch 2015. At Hermann Gmeiner School Bhimtal, we believe in cultivating brilliance through dedication, guidance, and an environment that nurtures potential—all while adhering to our vision of providing tuition-free education. <br />
                      After laying a strong base here and further sharpening her academic profile at Hindu College, Delhi, Saumya has cleared the Provincial Civil Services, securing the 10th Rank overall, and is now a Deputy Collector at Haridwar, India. What makes her journey even more inspiring is that she marked this incredible feat without any external coaching, relying solely on her hard work and the robust education she received.<br />
                      Saumya’s success is a testament to the values and vision of Hermann Gmeiner School—a place where geniuses are created, not by privilege, but by potential.
                      <br /><img className="highimageleft" src={require("../../image/boardingadmission/commisnor.png")} />
                    </p>
                  </div>
                </div>


              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="text-white text-center py-5 admission-open">
            <div className="container spacious">
              <h2 className="fw-bold text-white headingfont">Admissions Open for 2027–2028</h2>
              <p className="lead mb-3">Nursery–Grade 9 &amp; 11</p>
              <p className="quotes mb-3">“Step into a future of limitless learning — where curiosity meets innovation, and every child is empowered to lead with confidence.”</p>

              <p className="mb-4 text-start increasLine">

              </p>
              <a href="contact-us" className="btn btn-light btn-medium rounded-pill px-4 mx-2 my-4">
                Apply Online Now
              </a>
              <a href="contact-us" className="btn btn-light btn-medium rounded-pill px-4 mx-2 my-4">
                Talk to the Admission Counsellor
              </a>
              <a href="book-tour" className="btn btn-light btn-medium rounded-pill px-4 mx-2 my-4">
                Schedule a Campus Visit
              </a>
              <br />
            </div>
          </section>


          <section
            className="bg-light ftco-no-pt spacious admissioncriteria"
            style={{
              backgroundImage: "url(/static/media/faculty.3278c0484d6a8ca8bc81.jpeg) !important",
              backgroundRepeat: "no-repeat !important",
              backgroundSize: "cover !important",
              paddingTop: "2% !important"
            }}
          >
            <div className="container-xl">
              <div id="admission-criteria" className="row justify-content-center mb-5">
                <div
                  className="col-md-7 heading-section text-center aos-init aos-animate"
                  data-aos="fade-up"
                  data-aos-duration={1000}
                >
                  <h2 className="fw-bold headingfont">Admission Criteria</h2>
                </div>
              </div>
              <div>

                <div className="accordion" id="admissionaccord">

                  <div className="accordion-item border-0 mb-2 rounded-3">
                    <h2 className="accordion-header" id="heading-1">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapse-1"
                        aria-expanded='true'
                        aria-controls="collapse-1"
                      >
                        Admission Criteria
                      </button>
                    </h2>
                    <div
                      id="collapse-1"
                      className="accordion-collapse collapse"
                      aria-labelledby="heading-1"
                      data-bs-parent="#$admissionaccord"
                    >
                      <div className="accordion-body rounded-bottom">
                        <ol>
                          <li>Admission to the school is made without any distinction of religion, race, caste, place of birth, etc. </li>
                          <li>Admission is granted as and when vacancies are available in any class. </li>
                          <li>Admission forms are available in the school office depending upon the vacancy in different classes. </li>
                          <li>All admissions close by 31st August. Transfer cases from other states can be considered against vacancy even during the running session.</li>
                          <li>No admission is made until the student pass a test for the essential class subjects. A student who has attended a recognized school cannot be admitted without a School Leaving (Transfer) Certificate from the school last attended. Admission is strictly based on the performance in the entrance test from Grade IX onwards. However no test or interview is required for admission in Pre-Nursery and Nursery. The date of birth of a child that has been once declared in the Reg istration/Admission form and also in the Birth Certificate will not be changed under any circumstances. </li>
                          <li>Admission is confirmed only when the School receives the duly completed and signed Admission Form, along with supporting documents and the fees/deposits have been paid on or before the date declared by the School. </li>
                        </ol>
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item border-0 mb-2 rounded-3">
                    <h2 className="accordion-header" id="heading-2">
                      <button aria-controls="collapse-2" data-bs-target="#collapse-2" className="accordion-button collapsed" type="button" data-bs-toggle="collapse" aria-expanded='true'>
                        Admission in class IX
                      </button>
                    </h2>
                    <div id="collapse-2" aria-labelledby="heading-2" className="accordion-collapse collapse" data-bs-parent="#$admissionaccord">
                      <div className="accordion-body rounded-bottom">
                        For admission in class IX, the student must have completed his/her regular sessions of class VIII. The admission process will be conducted only for the students who were studying in any institution affiliated to state government/UT government or other certified boards.
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item border-0 mb-2 rounded-3">
                    <h2 className="accordion-header" id="heading-3">
                      <button aria-controls="collapse-3" data-bs-target="#collapse-3" className="accordion-button collapsed" type="button" data-bs-toggle="collapse" aria-expanded='true'>
                        Direct admission in class X and XII in schools
                      </button>
                    </h2>
                    <div id="collapse-3" aria-labelledby="heading-3" className="accordion-collapse collapse" data-bs-parent="#$admissionaccord">
                      <div className="accordion-body rounded-bottom">
                        Students who change schools while studying in class X or XII on the grounds of family relocation, distance, medical ground, etc. can be considered for admission provided the candidate seeks necessary approval from the respective boards and produce the required documents as per the guidelines.
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item border-0 mb-2 rounded-3">
                    <h2 className="accordion-header" id="heading-4">
                      <button aria-controls="collapse-4" data-bs-target="#collapse-4" className="accordion-button collapsed" type="button" data-bs-toggle="collapse" aria-expanded='true'>
                        Admission in class XI
                      </button>
                    </h2>
                    <div id="collapse-4" aria-labelledby="heading-4" className="accordion-collapse collapse" data-bs-parent="#$admissionaccord">
                      <div className="accordion-body rounded-bottom">
                        Students who have appeared/cleared their Grade X or equivalent exams from a recognized board are eligible for enrolment for 11th standard. However, it is mandatory to score the minimum to be eligible for further admission. The counselling will be conducted for Hermann Gmeiner School students and other students. Entrance tests will be conducted on the subjects offered, subject to the availability of vacancies.
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item border-0 mb-2 rounded-3">
                    <h2 className="accordion-header" id="heading-5">
                      <button aria-controls="collapse-5" data-bs-target="#collapse-5" className="accordion-button collapsed" type="button" data-bs-toggle="collapse" aria-expanded='true'>
                        Requirements
                      </button>
                    </h2>
                    <div id="collapse-5" aria-labelledby="heading-5" className="accordion-collapse collapse" data-bs-parent="#$admissionaccord">
                      <div className="accordion-body rounded-bottom">
                        <ol>
                          Those seeking admission should produce the following : <br />
                          <ul>
                            <li> Birth Certificate (for classes Pre-Nursery, Upper Nursery, Prep and Grade I). </li>
                            <li> A School Leaving Certificate from the school last attended (for classes 2 to 12). </li>
                            <li> Progress Report of the child indicating academic performance and participa- tion in co-curricular activities in the school last attended. </li>
                            <li> Registration with CBSE/State Board, in case, admission is sought in Class X or XII on genuine transfer of parents in addition to (2) & (3) above, and Copy of Transfer Order of parents. </li>
                            <li> PAN Card of Father and Mother</li>
                            <li> 4 passport size photographs of the student </li>
                            <li> Address Proof, Aadhar card of the child, father and mother </li>
                            <li> Medical Certificate </li>
                            <li> SC/ST/EWS/BPL/OBC Certificate if applicable </li>
                            <li> Income Certificate of father and mother * The child should complete 3 years for seeking admission in Pre Nursery and 6 years for Grade 1 as on 31st March of that academic year. </li>
                            * APAAR ID to be provided depending on school location.
                          </ul>
                        </ol>
                      </div>
                    </div>
                  </div>

                </div>

              </div>

            </div>
          </section>

        </div>


      </div>
      <Footer />
    </div>
  );
}
export default Admission;
